import { Realty, services } from '@ambita/ambita-components-core';
import { ApiCulturalHeritage } from '../../../typings/CadastreReport';

const util = services.util;

function transformCulturalHeritages(culturalHeritagesData: Realty.ApiResponse) {
  if (culturalHeritagesData.items && culturalHeritagesData.items.length > 0) {
    const culturalHeritages: ApiCulturalHeritage[] = culturalHeritagesData.items;
    const retObject: any = {
      culturalHeritages: []
    };

    culturalHeritages.forEach((culturalHeritage: ApiCulturalHeritage) => {
      const tmpObj: any = util.pick(culturalHeritage, [
        'ident',
        'objectName',
        'siteDating',
        'currentFunction',
        'originalFunction',
        'extension',
        'key'
      ]);

      retObject.culturalHeritages.push(tmpObj);
    });

    return retObject;
  }
}

export default transformCulturalHeritages;
